import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import ErrorBoundary from './MyComponents/ErrorBoundary/ErrorBoundary';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  
  // https://stackoverflow.com/questions/61254372/my-react-component-is-rendering-twice-because-of-strict-mode/72676006#72676006
  
  // StrictMode renders components twice (on dev but not production) in order to detect any problems 
  // with your code and warn you about them (which can be quite useful).

  // check this as well
  // https://stackoverflow.com/questions/60618844/react-hooks-useeffect-is-called-twice-even-if-an-empty-array-is-used-as-an-ar

  // <React.StrictMode>
  //   <App />
  // </React.StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
  // <CookiesProvider>
  // </CookiesProvider>
    

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
